import axios from "../api";
import _ from "lodash";
import PouchDB from "pouchdb";
import PouchDBFind from "pouchdb-find";
PouchDB.plugin(PouchDBFind);
import { dexie } from "../plugin/dexie";
import syncUtils from "../syncUtils";

var timer;
var repeatCount = 0;
const deWeight = (arr) => {
  let map = new Map();
  for (let item of arr) {
    if (!map.has(item.dbId)) {
      map.set(item.dbId, item);
    } else {
      let tmp = map.get(item.dbId);
      if (
        new Date(item.createdAt).getTime() > new Date(tmp.createdAt).getTime()
      ) {
        map.set(item.dbId, item);
      }
    }
  }
  return [...map.values()];
};

const actions = {
  setLanguage({ commit }, lang) {
    commit("SET_LANG", lang);
  },
  hasData({ commit }, data) {
    commit("SAVE_HAS_DATA", data);
  },
  // 获取全选状态
  setSelectShow({ commit }, val) {
    commit("SET_SELECT_SHOW", val);
  },
  setOverallShow({ commit }, show) {
    commit("SET_OVERALL_SHOW", show);
  },
  setHandleShow({ commit }, handle) {
    commit("SET_HANDLE_SHOW", handle);
  },
  // =========== IM消息相关 ==============
  updateMsgList({ commit }, list) {
    commit("UPDATE_MSG_LIST", list);
  },
  updateSessionList({ commit }, list) {
    commit("UPDATE_SESSION_LIST", list);
  },
  imUserItem({ commit }, item) {
    commit("CTRL_ITEM", item);
  },

  // 获取全选状态
  setPopup({ commit }, val) {
    commit("SET_SELECT_SHOW", val);
  },

  // ========== CB消息相关 ==================
  async getFeedbackUserFromDB({ commit, dispatch }) {
    let result = await dexie.users
      .orderBy("createdAt")
      .reverse()
      .toArray();
    let userList = deWeight(result);
    let ids = userList.map((j) => j.id);
    let tmp = result.filter((i) => !ids.includes(i.id));
    for (let item of tmp) {
      await dispatch("deleteFeedbackUser", item.id);
    }
    console.log("----------会话列表-------", userList);
    commit("UPDATE_CB_USER_LIST", userList);
    return userList;
  },
  async findFeedbackUserInDB({ commit, dispatch }, dbId) {
    const res = await dexie.users.get({ dbId });
    return res;
  },
  async setFeedbackUserInDB({ commit, dispatch }, msg) {
    const res = await dexie.users.add(msg);
    dispatch("getFeedbackUserFromDB");
    return "ok";
  },
  async updateFeedbackUserInDB({ commit, dispatch }, msg) {
    const res = await dexie.users.put(msg);
    dispatch("getFeedbackUserFromDB");
    return "ok";
  },
  async deleteFeedbackUser({ commit, dispatch }, id) {
    const res = await dexie.users.delete(id);
    dispatch("getFeedbackUserFromDB");
    return "ok";
  },

  // 过滤生成会话列表
  async filterFeedbackUserFromCB({ commit, dispatch }, { arr, type = "" }) {
    let msgList = deWeight(arr);
    let res = await dispatch("getFeedbackUserFromDB");
    let dbIds = res.map((item) => item.dbId) || [];
    for (let item of msgList) {
      let params = {
        conversationId: item.conversationId ? item.conversationId : null,
        dbId: item.dbId,
        name: item.name || "用户",
        lastMessage: item.isRevoke ? "消息已撤回" : item.desc,
        user: item.user,
        unReadCount: 0,
        createdAt: new Date(item.createdAt).getTime(),
        updatedAt: new Date(item.updatedAt).getTime(),
      };

      let tmp = await dispatch("getFeedbackMsgFromCb", {
        selector: {
          dbId: item.dbId,
          msgType: 0,
          $or: [{ isRead: false }, { isRead: { $exists: false } }],
        },
      });
      params.unReadCount = Number(tmp.length);
      if (item.msgType === 1) {
        let docs = await dispatch("getFeedbackMsgFromCb", {
          selector: { dbId: item.dbId, msgType: 0 },
          limit: 1,
        });
        params.name = docs.length
          ? docs[0].name
            ? docs[0].name
            : "用户"
          : "用户";

          item.user !== "onyx_admin" && (params.unReadCount = 0)
      }

      if (!dbIds.includes(item.dbId)) {
        await dispatch("setFeedbackUserInDB", params);
      } else {
        let tmp = res.find((ele) => ele.dbId === item.dbId);
        if (
          new Date(item.createdAt).getTime() >
            new Date(tmp.createdAt).getTime() ||
          (new Date(item.createdAt).getTime() ===
            new Date(tmp.createdAt).getTime() &&
            item.isRevoke)
        ) {
          params.id = tmp.id;
          await dispatch("updateFeedbackUserInDB", params);
        }
      }
    }
    return "ok";
  },

  initMsgCB({ commit, dispatch, state }) {
    let dbName = this.state.feedbackDbName;
    const remote = `${location.origin}/neocloud`;

    let opts = {
      live: true,
      retry: true,
      batch_size: 1000,
      filter: "sync_gateway/bychannel",
      query_params: {
        channels: "onyx_admin",
      },
      filter: function(doc) {
        let start = new Date(doc.createdAt).getTime();
        let end = new Date().getTime();
        var day = parseInt((end - start) / (24 * 60 * 60 * 1000));
        return day < 30;
      },
    };
    PouchDB.sync(dbName, remote, opts)
      .on("change", function(info) {
        console.log("==pzz change: ", info, info.change.docs);

        let arr = info.change.docs.filter(
          (item) => item.msgType === 0 || item.msgType === 1
        );
        dispatch("filterFeedbackUserFromCB", { arr });

        clearTimeout(timer);
        timer = setTimeout(() => {
          if (state.cbCurrentUser) {
            let tmp =
              info.change.docs.filter(
                (item) => item.dbId === state.cbCurrentUser.dbId
              ) || [];
            dispatch("mergeCbMsgList", tmp);
          }
        }, 500);
      })
      .on("paused", function(err) {
        // console.log("==pzz paused: ", err);
      })
      .on("active", function(info) {
        // console.log("== pzzactive: ", info);
      })
      .on("denied", function(err) {
        // console.log("==pzz denied: ", err);
      })
      .on("complete", function(info) {
        // console.log("==pzz complete: ", info);
      })
      .on("error", function(err) {
        // console.log("==pzz error: ", err);
      });
  },

  async pullCbMsgList({ commit }) {
    let dbName = this.state.feedbackDbName;
    let db = new PouchDB(dbName);
    const remote = `${location.origin}/neocloud`;
    try {
      const opts = {
        retry: true,
        batch_size: 100,
        filter: "sync_gateway/bychannel",
        query_params: {
          channels: "onyx_admin",
        },
        filter: function(doc) {
          let start = new Date(doc.createdAt).getTime();
          let end = new Date().getTime();
          var day = parseInt((end - start) / (24 * 60 * 60 * 1000));
          return day < 30;
        },
      };
      const rep = await db.replicate.from(remote, opts);
      console.log("==== pull rep: ", rep);
    } catch (err) {
      console.error(err);
    }
  },

  async pushCbMsgList({ commit, dispatch }) {
    let dbName = this.state.feedbackDbName;
    try {
      const rep = await syncUtils.push(dbName);
      repeatCount = 0;
      console.log("==== push rep: ", rep);
    } catch (error) {
      if (repeatCount !== 5) {
        repeatCount += 1;
        dispatch("pushCbMsgList");
      } else {
        repeatCount = 0;
        throw new Error(error);
      }
    }
  },

  async getFeedbackMsgFromCb({ commit }, params) {
    let dbName = this.state.feedbackDbName;
    let db = new PouchDB(dbName);
    const result = await db.find(params);
    let list = result.docs.filter(
      (item) => item.msgType === 0 || item.msgType === 1
    );
    list = _.orderBy(list, ["createdAt"], ["asc"]);
    return list;
  },

  async updateFeedbackMsg({ commit, dispatch }, params) {
    let dbName = this.state.feedbackDbName;
    let db = new PouchDB(dbName);
    let res = await db.put(params);
    dispatch("pushCbMsgList");
    return res;
  },

  async submitFeedbackMsgToCb({ commit, dispatch }, msg) {
    let dbName = this.state.feedbackDbName;
    let db = new PouchDB(dbName);
    let res = await db.put(msg);
    let docs = await dispatch("getFeedbackMsgFromCb", {
      selector: { _id: res.id },
    });
    dispatch("pushCbMsgList");
    return docs;
  },

  mergeCbMsgList({ commit, dispatch }, arr) {
    commit("MERGE_CB_MSG_LIST", arr);
  },
  updateCbMsgList({ commit, dispatch }, list) {
    commit("UPDATE_CB_MSG_LIST", list);
  },
  setCbCurrentUser({ commit, dispatch }, item) {
    commit("SET_CB_CURRENT_USER", item);
  },

  // ==================================================

  // =============== 第三方服务配置 =====================

  // 获取第三方服务配置详情
  async getServiceConfigDetails({ commit, dispatch }, id) {
    try {
      let dbName = "CloudConfig";
      let db = new PouchDB(dbName);
      let params = {
        selector: {
          _id: id,
          msgType: 4,
        },
      };
      let res = await db.find(params);
      return res.docs;
    } catch (error) {
      throw new Error(error);
    }
  },

  //  删除第三方服务配置
  async delServiceConfigItem({ commit, dispatch }, params) {
    try {
      let dbName = "CloudConfig";
      let db = new PouchDB(dbName);
      let res = await db.remove(params);
      await syncUtils.push(dbName);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  },

  //  更新第三方服务配置
  async updateServiceConfigItem({ commit, dispatch }, params) {
    try {
      let dbName = "CloudConfig";
      let db = new PouchDB(dbName);
      let res = await db.put(params);
      await syncUtils.push(dbName);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  },

  // ==================================================

  // 验证路由权限
  getRouter({ commit }, role_id) {
    return new Promise((resolve, reject) => {
      axios
        .getRoleModules(role_id)
        .then((res) => {
          let routerRole = res.data.rows.map((item) => item.name);
          commit("SET_ROUTER", routerRole);
          resolve("ok");
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户信息
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .getUser()
        .then((res) => {
          commit("USER_INFO", res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取书籍分类
  getBookCategories({ commit }) {
    return new Promise((resolve, reject) => {
      axios.getBookCategories().then((res) => {
        commit("SAVE_CATEGORIES", res.data);
        resolve(res.data);
      });
    });
  },

  // 获取频道
  getBookChannels({ commit }, lang) {
    return new Promise((resolve, reject) => {
      let params = {
        lang: lang || "",
      };
      axios.getBookChannels(params).then((res) => {
        commit("SAVE_CHANNELS", res.data);
        resolve(res.data);
      });
    });
  },
};

export default actions;
